module.exports = __webpack_public_path__ + "img/logo.43389fe8.png";